import axios, { AxiosError } from 'axios';

const API_BASE_URL = import.meta.env.VITE_API;

// Interface pour un email de notification
export interface EmailItem {
  id: string;
  email: string;
}

// Créer une instance axios avec les headers communs
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials:true

});

// Intercepteur pour ajouter le token à chaque requête
// apiClient.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem('access_token');
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => error
// );
apiClient.interceptors.response.use(response =>   
  {
    console.log('headerrr new',response?.headers)

    return response
  },   
  async error => {
    console.log("interceptors call here")

    const originalRequest = error.config;    
    const is401 = error.response?.status === 401;    
    const reauth = error.response?.headers['x-reauth'] === 'true';
    console.log("reauth value", reauth)
    console.log("already retrying", !originalRequest._retry)
    console.log("Is401 response value", is401)

    if (is401 && reauth && !originalRequest._retry) 
      {
        originalRequest._retry = true;
        console.log("retry de la requete in process")
        try {       
           return await apiClient(originalRequest);      
          } catch (err) {
               return Promise.reject(err);      
              }    
            }    
        return Promise.reject(error);
        });



// URL endpoint pour les emails de notification
export const getNotificationEmailsUrl = (companyId: string) => 
  `/Company/${companyId}/notification_list`;

// Fonction fetcher pour SWR (si nécessaire)
export const fetcher = (url: string) => apiClient.get(url).then(res => res.data).catch(errors => errors.data);

/**
 * Récupérer la liste des emails de notification
 */
export const fetchNotificationEmails = async (companyId: string): Promise<EmailItem[]> => {
  try {
    if (!companyId) {
      console.error("CompanyId est requis pour charger les emails de notification");
      return [];
    }
    
    const response = await apiClient.get(getNotificationEmailsUrl(companyId));
    
    // Vérifier la structure de la réponse
    console.log("Réponse API notification_list:", response.data);
    
    // Vérification et traitement des données
    if (response.data && Array.isArray(response.data.data)) {
      return response.data.data;
    } else if (response.data && Array.isArray(response.data)) {
      return response.data;
    } else {
      console.warn("Format de réponse inattendu:", response.data);
      return [];
    }
  } catch (error) {
    const axiosError = error as AxiosError;
    console.error("Erreur lors du chargement des emails de notification:", axiosError.response);
    throw error; // Faire remonter l'erreur pour la gérer dans le composant
  }
};

/**
 * Ajouter un nouvel email de notification
 */
export const addNotificationEmail = async (companyId: string, email: string): Promise<any> => {
  try {
    if (!companyId) {
      console.error("CompanyId est requis pour ajouter un email");
      throw new Error('CompanyId is required');
    }
    
    if (!email) {
      console.error("Email est requis");
      throw new Error('Email is required');
    }
    
    console.log(`Tentative d'ajout de l'email ${email} pour la société ${companyId}`);
    
    const response = await apiClient.post(
      getNotificationEmailsUrl(companyId),
      { email }
    );
    
    console.log("Réponse après ajout:", response.data);
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    console.error("Erreur lors de l'ajout de l'email de notification:", axiosError);
    console.error("Détails:", axiosError.response?.data);
    throw error; // Faire remonter l'erreur pour la gérer dans le composant
  }
};

/**
 * Modifier un email de notification
 */
export const updateNotificationEmail = async (
  companyId: string,
  notifEmailId: string,
  email: string
): Promise<any> => {
  try {
    if (!companyId) {
      console.error("CompanyId est requis pour modifier un email");
      throw new Error('CompanyId is required');
    }
    
    if (!notifEmailId) {
      console.error("notifEmailId est requis");
      throw new Error('notifEmailId is required');
    }
    
    if (!email) {
      console.error("Email est requis");
      throw new Error('Email is required');
    }
    
    console.log(`Tentative de modification de l'email ${notifEmailId} pour la société ${companyId}`);
    
    const response = await apiClient.put(
      `/Company/${companyId}/notification_list/${notifEmailId}`,
      { email }
    );
    
    console.log("Réponse après modification:", response.data);
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    console.error("Erreur lors de la modification de l'email de notification:", axiosError);
    console.error("Détails:", axiosError.response?.data);
    throw error;
  }
};

/**
 * Supprimer un email de notification
 */
export const removeNotificationEmail = async (
  companyId: string,
  notifEmailId: string
): Promise<any> => {
  try {
    if (!companyId) {
      console.error("CompanyId est requis pour supprimer un email");
      throw new Error('CompanyId is required');
    }
    
    if (!notifEmailId) {
      console.error("notifEmailId est requis");
      throw new Error('notifEmailId is required');
    }
    
    console.log(`Tentative de suppression de l'email ${notifEmailId} pour la société ${companyId}`);
    
    const response = await apiClient.delete(
      `/Company/${companyId}/notification_list/${notifEmailId}`
    );
    
    console.log("Réponse après suppression:", response.data);
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    console.error("Erreur lors de la suppression de l'email de notification:", axiosError);
    console.error("Détails:", axiosError.response?.data);
    throw error;
  }
};

/**
 * Valider un format d'email
 */
export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};
